module.exports = __webpack_public_path__ + "media/images/e-kvitok/down-arrow-select-0ceb4cdb9ca722221b1007e14886516f.svg";